const Form052TC = {
    stepName: {
        schoolInfor: "學校信息",
        partA: "甲部：申領輔助人員現金津貼",
        partB: "乙部：認證",
        confirmation: "確認",
    },
    errorMsg: {
        shorter: "空缺職位凍結期不得少於30天",
        laterThanDate: "日期不得晚於或早於本學科學年的8月31日",
    },
    label: {
        statement: "個人信息收集聲明",
        read: "本人已閱讀，明白及同意上述條款及細則",
        read2: "本人理解申請人和教師需要擁有「智方便+」帳戶才能處理申請。",
        ssdo: "高級學校發展主任",
        schoolYear: "學年",
        schoolName: "學校名稱",
        schoolCode: "學校代碼",
        cashGrant: "申領輔助人員現金津貼",
        vacant: "本校欲暫時凍結核准編制內的",
        applyTitle: "請選擇部門",
        approved: "職位，以申領輔助人員現金津貼。",
        postNumber: "申領{{cash}}的空缺職位數目",
        claim: "新申領津貼的職位／修訂",
        previousClaim: "不更改先前申領／刪除先前申領／更改先前申領",
        previousClaimNumber: "請註明前次申領的申請編號",
        errorPreNum: "前次申領的申請編號",
        fromDate: "空缺職位凍結期由",
        toDate: "空缺職位凍結期至（日／月／年）",
        qualifiedNumber: "合資格月數",
        salary: "月薪",
        subsidy: "強積金供款津貼",
        mpfAttachment: "強積金供款證明資料",
        amount: "{{cash}}金額",
        previousClaimDated: "前次申領表格日期",
        previousClaimAttachment: "隨附（前次日期）的申領表格副本",
        declaration: "本人證實—",
        establishment: "{{name}}核准編制",
        vacancy: "{{name}}職位空缺",
        fileReference: "教育局批函檔號",
        colon: "；",
        space: "",
        supervisorName: "校監姓名",
        date: "日期",
        contactPerson: "聯絡人",
        telNo: "電話號碼",
        ssdo1: "致：學校所屬地區的區域教育服務處【經辦人：（",
        ssdo2: "）】",
    },
    sectionOption: {
        School: "學校部",
        Boarding: "宿舍部",
    },
    cashValue: {
        TeacherAssistant: "教師助理",
        Cook: "廚師",
        SchoolBusDriver: "特級司機",
        Watchman: "看守員",
    },
    postValue: {
        TeacherAssistant: "教師助理",
        Cook: "廚師",
        SchoolBusDriver: "校巴司機",
        Watchman: "看守員",
    },
    post1Value: {
        teacherAssistant: "教師助理",
        cook: "廚師",
        specialDriver: "特級司機",
        watchman: "看守員",
    },
    sectionValue: {
        TeacherAssistant: "教師助理現金津貼",
        Cook: "廚師現金津貼",
        SchoolBusDriver: "校巴司機現金津貼",
        Watchman: "看守員現金津貼",
    },
    claimValue: { N: "新申領津貼的職位", R: "修訂" },
    previousClaimValue: {
        unchange: "不更改先前申領",
        delete: "刪除先前申領",
        change: "更改先前申領",
    },
    salaryValue: {
        pt4: "16565",
        pt7: "20035",
        pt8: "21340",
        pt9: "22725",
    },
    sSDOValue: {
        0: "北區",
        1: "葵青區",
        2: "西貢區",
        3: "東區",
        4: "屯門區",
        5: "九龍城區",
        6: "觀塘區",
        7: "南區",
        8: "油尖旺區",
        9: "荃灣區",
        10: "沙田區",
        11: "深水埗區",
        12: "大埔區",
        13: "灣仔區",
        14: "離島區",
        15: "中西區",
        16: "元朗區",
        17: "黃大仙區",
    },
    note1: [
        {
            text: "1. 計算由起始日直至完結日（首尾兩天包括在內）的合資格申領輔助人員現金津貼月數，包含以下3個元素：",
        },
        {
            text: "（i）合資格日數在起始月份的曆日總數中所佔的比例（如適用）；",
        },
        {
            text: "（ii）完整的曆月數（如適用）；以及",
        },
        {
            text: "（iii）合資格日數在完結月份曆日總數中所佔的比例（如適用）。",
        },
        {
            text: "例如：",
        },
        {
            text: "假設合資格申領輔助人員現金津貼的時期是由2月5日至5月26日，計算合資格月數的方法如下：",
        },
        {
            text: "（i）起始月份的合資格日數為24日（2月5日至2月28日）除以28日（2月份的曆日總數）= 0.857個月；",
        },
        {
            text: "（ii) 由3月至4月有兩個完整的曆月數；",
        },
        {
            text: "（iii）完結月份的合資格日數為26日（5月1日至26）除以31日（5月份的曆日總數）= 0.839個月。",
        },
        {
            text: "因此，合資格申領月數應為上述3個元素的總和（計算至3個小數位），即0.857 + 2 + 0.839 = 3.696（個月）。",
        },
    ],
    note2: [
        {
            text: "2. 請填寫相關職位的中點薪金金額。相關輔助人員的中點薪金已載列於教育局通告第5／2021號，表列如下：",
        },
        {
            text: "有關各項輔助人員現金津貼的用途及行政安排，請參閱教育局通告第5／2021號。",
        },
    ],
    note2Row: {
        post: "職位",
        salary: "中點薪金",
    },
    note2Cell: {
        teacherAssistant: "教師助理",
        cook: "廚師",
        specialDriver: "特級司機",
        watchman: "看守員",
    },
    note2Value: [
        { text: "第一標準薪級表第4點" },
        { text: "總薪級表第7點" },
        { text: "總薪級表第9點" },
        { text: "第一標準薪級表第8點" },
    ],
    note3: "3. 如合資格申領期達60天或以上，強積金計劃僱主供款（月薪的5%，並以現行強積金規例所訂的最高金額為上限）將會包括在內，金額以四捨五入計算至2個小數位。如換取現金津貼的輔助人員職位空缺凍結期少於60天，而須向強積金供款，請提供證明資料。",
    note4: "4. 每次金額的計算均以四捨五入至2個小數位。",
    note5: "不得少於30天",
    lableStep: [
        { step: "（i）" },
        { step: "（ii）" },
        { step: "（iii）" },
        { step: "（iv）" },
        { step: "（v）" },
    ],
    certify: {
        note1: "本校的法團校董會及大多數",
        note2: "已同意於上述學年期間凍結上述職位；",
        note3: "凍結甲部所載的",
        note4: "的職位並申領輔助人員現金津貼，是因為該（等）核准編制的職位在上述期間有空缺及此項申領符合津貼所列明的申領條件；",
        note5: "申領輔助人員現金津貼的凍結職位於上述期間並無超逾本校的該（等）核准編制（教育局批函檔案 :",
        note6: "",
        note7: "）。本校有上述輔助人員職位的空缺（",
        note8: "），在凍結有關人員職位時，空缺的數目會被抵銷；",
        note9: "本校沒有就上述甲部的職位空缺向政府申領其他津貼；以及",
        note10: "本人明白上述輔助人員現金津貼的安排，讓學校在人事聘任上更富彈性，以配合學校的運作和學生的需要。",
        note11: "本人確認本表格所載的資料均正確無誤。",
        note12: "本校會把任何多收取的津貼退還教育局。",
    },
};
export default Form052TC;
